


















































































































































enum SetAttributeSteps {
  ActionSelect,
  SetValue,
}

import { snakeCase } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import { SelectOption } from '../../../../../logic/types'
import { atSignedLogin } from '../../../../../shared/utils/tgLoginHelpers'
import { User } from '../../../../BotUsers/components/Users/types'
import SelectInput from '../../../../Pi/fields/SelectInput/SelectInput.vue'
import TextInput from '../../../../Pi/fields/TextInput/TextInput.vue'
import UserMainInfo from "../../../../UserMainInfo.vue";
import { ProfileCardHelper, UserAttributes, UserAttributesEnum } from '../../../types'

@Component({
  components: {
    SelectInput,
    TextInput,
    ValidationObserver,
    UserMainInfo
  },
  data() {
    return {
      UserAttributesEnum,
      SetAttributeSteps,
      atSignedLogin,
    }
  }
})
export default class SetUserAttributes extends Mixins(ModelSetter) {
  @Prop() userId!: number

  @Prop() utm!: User['utm']

  @Prop() referrer!: User['referrer']

  @Prop() setUserAttributesInfo!: ProfileCardHelper['setUserAttributeInfo']

  @Emit()
  updateProfile() {
    return null
  }

  @Watch('attribute.attribute')
  onAttributeChange() {
    this.changeStep(SetAttributeSteps.ActionSelect)

    this.resetAttributeValue()
  }

  isSetAttributeModalOpen = false

  savingAttribute = false

  currentStep = SetAttributeSteps.ActionSelect;

  attribute: UserAttributes = this.defaultAttributeModel()

  get attributeOptions(): Array<SelectOption> {
    return Object.values(UserAttributesEnum).map(k => ({
      label: this.$t(`user_attribute_${ snakeCase(k).toLowerCase() }_option`).toString(),
      value: k
    }))
  }

  get oneOfAttributesExists() {
    return (this.referrer && this.attribute.attribute === UserAttributesEnum.ReferringUser)
      || (this.utm && this.attribute.attribute === UserAttributesEnum.Utm)
  }

  defaultAttributeModel(): UserAttributes {
    return {
      attribute: UserAttributesEnum.Utm,
      value: ''
    }
  }

  changeStep(step: SetAttributeSteps) {
    this.currentStep = step
  }

  setUserAttribute(attribute: UserAttributes) {
    if (this.setUserAttributesInfo) {
      this.savingAttribute = true

      this.setUserAttributesInfo.setUserAttribute(this.userId, attribute)
        .then(value => {
          if (value) {
            this.isSetAttributeModalOpen = false

            this.updateProfile()

            this.attribute = this.defaultAttributeModel()
            this.changeStep(SetAttributeSteps.ActionSelect)
          }
        })
        .finally(() => this.savingAttribute = false)
    }
  }

  resetAttribute() {
    const attribute: UserAttributes = { ...this.attribute }

    attribute.value = null;

    this.setUserAttribute(attribute)
  }

  prepareAttribute(attribute: UserAttributes) {
    const attr = attribute

      if (attr.value !== null && attr.attribute === UserAttributesEnum.ReferringUser) {
        attr.value = +attr.value
    }

    return attr
  }

  saveAttribute() {
    this.setUserAttribute(this.prepareAttribute(this.attribute))
  }

  onBackClick() {
    this.changeStep(SetAttributeSteps.ActionSelect)

    this.resetAttributeValue();
  }

  resetAttributeValue() {
    this.attribute.value = ''
  }
}
